export default __webpack_public_path__ + "static/media/hop6.5c931ca9.jpg";